/* Essential Add-ons (Spike-style) - BrewTaurus
 * - Live "Estimated Total" = current main variant price + checked add-ons
 * - On Add to cart: checked add-ons are added first via /cart/add.js,
 *   then the theme's own product form submit continues untouched,
 *   so the native cart drawer / cart page shows everything.
 * - v2: per-row stock badge follows the selected add-on variant.
 * - v3 (22. 9. 2026): variant switch honours pre-order (row data-preorder /
 *   data-preorder-eta) and "Available to order" (option data-order),
 *   mirroring essential-addons.liquid + stock-badge.liquid.
 */
(function () {
  'use strict';

  if (customElements.get('essential-addons')) return;

  class EssentialAddons extends HTMLElement {
    connectedCallback() {
      this.moneyFormat = this.dataset.moneyFormat || '€{{amount_with_comma_separator}} EUR';
      this.mainPrice = parseInt(this.dataset.mainPrice, 10) || 0;
      try {
        var el = this.querySelector('[data-role="main-variants"]');
        this.mainVariants = el ? JSON.parse(el.textContent) : {};
      } catch (e) {
        this.mainVariants = {};
      }

      this.form = this.findProductForm();
      this.totalEl = this.querySelector('[data-role="total"]');

      this.addEventListener('change', this.onChange.bind(this));
      this.bindSubmitInterceptor();
      this.watchMainVariant();
      this.updateTotal();
    }

    findProductForm() {
      var section = this.closest('.shopify-section') || document;
      var sectionId = this.dataset.sectionId;
      return (
        (sectionId && document.getElementById('product-form-' + sectionId)) ||
        section.querySelector('form[data-type="add-to-cart-form"]') ||
        document.querySelector('form[data-type="add-to-cart-form"]')
      );
    }

    onChange(evt) {
      var target = evt.target;
      if (target.matches('[data-role="variant"]')) {
        var row = target.closest('.essential-addons__row');
        var check = row.querySelector('.essential-addons__check');
        var opt = target.options[target.selectedIndex];
        check.dataset.variantId = opt.value;
        check.dataset.price = opt.dataset.price;
        var priceEl = row.querySelector('[data-role="row-price"]');
        if (priceEl) priceEl.textContent = this.formatMoney(parseInt(opt.dataset.price, 10));
        this.updateRowStock(row, opt);
      }
      this.updateTotal();
    }

    updateRowStock(row, opt) {
      if (row.hasAttribute('data-fixed-stock')) return;
      var stockEl = row.querySelector('[data-role="stock"]');
      if (!stockEl) return;
      var avail = opt.dataset.avail !== '0';
      var isOrder = opt.dataset.order === '1';
      var isPreorder = row.dataset.preorder === '1';
      var qtyStr = opt.dataset.qty;
      var html;
      if (!avail) {
        html = '<span class="ea-stock ea-stock--out">Out of stock</span>';
      } else if (qtyStr === undefined || qtyStr === '') {
        html = '<span class="ea-stock ea-stock--in">In stock</span>';
      } else {
        var q = parseInt(qtyStr, 10);
        if (q >= 5) {
          html = '<span class="ea-stock ea-stock--in">5+ in stock</span>';
        } else if (q > 0) {
          html = '<span class="ea-stock ea-stock--low">Only ' + q + ' left</span>';
        } else if (isPreorder) {
          var eta = this.escapeHtml(row.dataset.preorderEta || '') || 'date TBC';
          html =
            '<span class="ea-stock ea-stock--preorder">Pre-order &middot; ships ' + eta + '</span>' +
            '<span class="ea-stock__note">Your whole order ships together once it arrives.</span>';
        } else if (isOrder) {
          html = '<span class="ea-stock ea-stock--low">Available to order</span>';
        } else {
          html = '<span class="ea-stock ea-stock--in">In stock</span>';
        }
      }
      stockEl.innerHTML = html;
    }

    escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    watchMainVariant() {
      if (!this.form) return;
      var self = this;
      var idInput = this.form.querySelector('[name="id"]');
      var refresh = function () {
        setTimeout(function () {
          var input = self.form.querySelector('[name="id"]');
          if (!input) return;
          var price = self.mainVariants[input.value];
          if (typeof price === 'number') self.mainPrice = price;
          self.updateTotal();
        }, 150);
      };
      var section = this.closest('.shopify-section') || document;
      section.addEventListener('change', refresh);
      if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        try { window.subscribe(window.PUB_SUB_EVENTS.variantChange, refresh); } catch (e) { /* noop */ }
      }
      if (idInput) refresh();
    }

    checkedItems() {
      var items = [];
      this.querySelectorAll('.essential-addons__check:checked:not(:disabled)').forEach(function (c) {
        var id = parseInt(c.dataset.variantId, 10);
        if (id) items.push({ id: id, quantity: 1 });
      });
      return items;
    }

    updateTotal() {
      if (!this.totalEl) return;
      var total = this.mainPrice;
      this.querySelectorAll('.essential-addons__check:checked:not(:disabled)').forEach(function (c) {
        total += parseInt(c.dataset.price, 10) || 0;
      });
      this.totalEl.textContent = this.formatMoney(total);
    }

    bindSubmitInterceptor() {
      if (!this.form || this.form.dataset.eaBound) return;
      this.form.dataset.eaBound = '1';
      var self = this;
      document.addEventListener(
        'submit',
        function (evt) {
          if (evt.target !== self.form) return;
          if (self.form.dataset.eaPass === '1') {
            setTimeout(function () { delete self.form.dataset.eaPass; }, 1000);
            return;
          }
          var items = self.checkedItems();
          if (!items.length) return;

          evt.preventDefault();
          evt.stopImmediatePropagation();

          fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .catch(function () { /* even if add-ons fail, continue with main product */ })
            .then(function () {
              self.form.dataset.eaPass = '1';
              if (typeof self.form.requestSubmit === 'function') {
                self.form.requestSubmit();
              } else {
                self.form.submit();
              }
            });
        },
        true
      );
    }

    formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var withComma = value.replace('.', ',');
      var noDecimals = String(Math.round(cents / 100));
      return this.moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, value);
    }
  }

  customElements.define('essential-addons', EssentialAddons);
})();
